import { render, staticRenderFns } from "./ConsultingPageEng.vue?vue&type=template&id=8fcb03e2&scoped=true&"
var script = {}
import style0 from "./ConsultingPageEng.vue?vue&type=style&index=0&id=8fcb03e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcb03e2",
  null
  
)

export default component.exports